import { useEffect, useState, type ReactNode } from "react";
import { Alert, Box, CircularProgress } from "@mui/material";
import { useAuthApi } from "./hooks/useAuthApi";
import { MGMT } from "./env";

type Status = "loading" | "ok" | "forbidden";

export default function TenantGuard({ children }: { children: ReactNode }) {
  const authApi = useAuthApi();
  const [status, setStatus] = useState<Status>("loading");

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        await authApi(`${MGMT}/users/me`);
        if (!cancelled) setStatus("ok");
      } catch {
        if (!cancelled) setStatus("forbidden");
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [authApi]);

  if (status === "loading") {
    return (
      <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", minHeight: "100vh" }}>
        <CircularProgress />
      </Box>
    );
  }

  if (status === "forbidden") {
    return (
      <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", minHeight: "100vh", p: 4 }}>
        <Alert severity="error" sx={{ maxWidth: 540 }}>
          <strong>Access denied.</strong> Your account is not linked to a company tenant. Contact a Zennet platform
          administrator to provision access in the admin portal.
        </Alert>
      </Box>
    );
  }

  return <>{children}</>;
}
